module.exports = __webpack_public_path__ + "static/Zanipar Siadari-00cde8f82e0dee56716d1935e08c86f3.jpg";